<template>
    <el-dialog
        :title="isView ? '查看平台艺人' : '关联平台艺人'"
        :visible.sync="visible"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="!fetchLoading"
        :show-close="!fetchLoading"
        width="75%"
        top="2vh"
        class="artist-drawer-dialog"
        @closed="closed"
        v-loading="fetchLoading"
        element-loading-text="数据加载中..."
    >
        <div class="drawer-content">
            <div class="instruction-box">
                <div class="instruction-title">说明</div>
                <div class="instruction-list">
                    <div>1. 如果艺人在对应平台已有主页，建议搜索并关联已有主页，以避免作品进入错误主页。</div>
                    <div>2. 可通过艺人名称或艺人ID搜索平台艺人，并选择正确的搜索结果。</div>
                    <div>3. 如暂时无法搜索艺人信息，可直接使用艺人ID完成关联。</div>
                    <div>4. 如没有可关联的主页，可按平台能力选择由平台创建（仅部分平台支持）。</div>
                </div>
            </div>
            <p class="section-tip">以下是{{ isAlbum ? '专辑' : '歌曲' }}中所有演唱艺人，你可以为每位艺人关联各平台主页</p>
            <div class="artist-list">
                <div v-for="(artist, index) in tableData" :key="artist.id || index" class="artist-card-wrapper">
                    <div class="artist-info-card">
                        <div class="artist-left">
                            <div class="artist-name">{{ queryArtistRoleInfo(artist.id) && queryArtistRoleInfo(artist.id).artistName }}</div>
                            <div class="artist-role-tag">
                                {{ queryArtistRoleInfo(artist.id) && queryArtistRoleInfo(artist.id).roleInfo }}
                            </div>
                            <div class="related-count">
                                已关联 {{ getRelatedCount(artist) }} / 4 个平台
                                <el-tooltip content="关联平台主页可以提高作品分发准确率" placement="top">
                                    <i class="el-icon-info"></i>
                                </el-tooltip>
                            </div>
                        </div>
                        <div class="platform-cards">
                            <!-- Apple Music: platformType=3 -->
                            <apple-spotify-relase
                                :is-view="isView"
                                :cover-url="getPlatformInfo(artist, 3).coverUrl"
                                :store-url="getPlatformInfo(artist, 3).storeUrl"
                                type="appleMusic"
                                :has-release-id="isPlatformBound(artist, 3)"
                                :platform-status="getPlatformByType(artist, 3) && getPlatformByType(artist, 3).status"
                                :artist-name="getPlatformInfo(artist, 3).artistName"
                                :artist-id="getPlatformInfo(artist, 3).platformArtistId"
                                @handleRelease="openPlatformDrawer(1, artist)"
                                @handleUnRelease="handleUnRelease(1, artist)"
                                @handleStore="handleStore(1, artist)"
                                @handleEdit="openPlatformDrawer(1, artist)"
                                @handleInputId="openPlatformDrawer(1, artist)"
                            ></apple-spotify-relase>
                            <!-- Spotify: platformType=4 -->
                            <apple-spotify-relase
                                :is-view="isView"
                                :cover-url="getPlatformInfo(artist, 4).coverUrl"
                                :store-url="getPlatformInfo(artist, 4).storeUrl"
                                type="Spotify"
                                :has-release-id="isPlatformBound(artist, 4)"
                                :platform-status="getPlatformByType(artist, 4) && getPlatformByType(artist, 4).status"
                                :artist-name="getPlatformInfo(artist, 4).artistName"
                                :artist-id="getPlatformInfo(artist, 4).platformArtistId"
                                @handleRelease="openPlatformDrawer(2, artist)"
                                @handleUnRelease="handleUnRelease(2, artist)"
                                @handleStore="handleStore(2, artist)"
                                @handleEdit="openPlatformDrawer(2, artist)"
                                @handleInputId="openPlatformDrawer(2, artist)"
                            ></apple-spotify-relase>
                            <!-- QQ音乐: platformType=2 -->
                            <apple-spotify-relase
                                :is-view="isView"
                                :cover-url="getPlatformInfo(artist, 2).coverUrl"
                                :store-url="getPlatformInfo(artist, 2).storeUrl"
                                type="qqMusic"
                                :has-release-id="isPlatformBound(artist, 2)"
                                :platform-status="getPlatformByType(artist, 2) && getPlatformByType(artist, 2).status"
                                :artist-name="getPlatformInfo(artist, 2).artistName"
                                :artist-id="getPlatformInfo(artist, 2).platformArtistId"
                                @handleRelease="openPlatformDrawer(3, artist)"
                                @handleUnRelease="handleUnRelease(3, artist)"
                                @handleStore="handleStore(3, artist)"
                                @handleEdit="openPlatformDrawer(3, artist)"
                                @handleInputId="openPlatformDrawer(3, artist)"
                            ></apple-spotify-relase>
                            <!-- 网易云音乐: platformType=1 -->
                            <apple-spotify-relase
                                :is-view="isView"
                                :cover-url="getPlatformInfo(artist, 1).coverUrl"
                                :store-url="getPlatformInfo(artist, 1).storeUrl"
                                type="netease"
                                :has-release-id="isPlatformBound(artist, 1)"
                                :platform-status="getPlatformByType(artist, 1) && getPlatformByType(artist, 1).status"
                                :artist-name="getPlatformInfo(artist, 1).artistName"
                                :artist-id="getPlatformInfo(artist, 1).platformArtistId"
                                @handleRelease="openPlatformDrawer(4, artist)"
                                @handleUnRelease="handleUnRelease(4, artist)"
                                @handleStore="handleStore(4, artist)"
                                @handleEdit="openPlatformDrawer(4, artist)"
                                @handleInputId="openPlatformDrawer(4, artist)"
                            ></apple-spotify-relase>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer-wrapper">
            <div class="footer-content">
                <el-button @click="visible = false" :disabled="fetchLoading" class="footer-close-btn">关闭</el-button>
                <div class="footer-tip">
                    <i class="el-icon-info"></i>
                    关联的艺人ID将用于作品分发。请确认所选主页属于正确艺人。
                </div>
            </div>
        </div>

        <!-- 平台关联详情抽屉 -->
        <el-drawer
            :visible.sync="platformDrawerVisible"
            :title="platformDrawerTitle"
            direction="rtl"
            size="60%"
            :append-to-body="true"
            :destroy-on-close="true"
            :close-on-click-modal="false"
            class="platform-detail-drawer"
            @close="closePlatformDrawer"
        >
            <div v-if="platformDrawerVisible && currentArtist" class="drawer-artist-info">
                <div class="current-artist-box">
                    <div class="current-artist-label">当前艺人</div>
                    <div class="current-artist-name">{{ currentArtistInfo.artistName }}</div>
                    <div class="current-artist-role">{{ currentArtistInfo.roleInfo }}</div>
                </div>
            </div>

            <!-- Apple Music -->
            <platform-apple-spotify-detail
                v-if="platformDrawerVisible && currentPlatformType === 1 && currentArtist"
                :is-drawer="true"
                :default-bind-mode="defaultBindMode"
                :artist-id="currentArtist.id"
                :artist-name="currentArtistInfo.artistName"
                :hide-sync-button="true"
                :display-lang-code="displayLangCode"
                platform-type="apple"
                @close="closePlatformDrawer"
                @bind-changed="onPlatformBindChanged"
            />

            <!-- Spotify -->
            <platform-apple-spotify-detail
                v-if="platformDrawerVisible && currentPlatformType === 2 && currentArtist"
                :is-drawer="true"
                :default-bind-mode="defaultBindMode"
                :artist-id="currentArtist.id"
                :artist-name="currentArtistInfo.artistName"
                :hide-sync-button="true"
                platform-type="spotify"
                @close="closePlatformDrawer"
                @bind-changed="onPlatformBindChanged"
            />

            <!-- QQ音乐 -->
            <platform-qq-netease-detail
                v-if="platformDrawerVisible && currentPlatformType === 3 && currentArtist"
                :is-drawer="true"
                :default-bind-mode="defaultBindMode"
                :artist-id="currentArtist.id"
                :artist-name="currentArtistInfo.artistName"
                :hide-sync-button="true"
                platform-type="qq"
                @close="closePlatformDrawer"
                @bind-changed="onPlatformBindChanged"
            />

            <!-- 网易云音乐 -->
            <platform-qq-netease-detail
                v-if="platformDrawerVisible && currentPlatformType === 4 && currentArtist"
                :is-drawer="true"
                :default-bind-mode="defaultBindMode"
                :artist-id="currentArtist.id"
                :artist-name="currentArtistInfo.artistName"
                :hide-sync-button="true"
                platform-type="netease"
                @close="closePlatformDrawer"
                @bind-changed="onPlatformBindChanged"
            />
        </el-drawer>
    </el-dialog>
</template>

<script>
import {fetchListRelateArtist, unrelatePlatformArtist} from '@/api/album';
import appleSpotifyRelase from './appleSpotifyRelase.vue';
import PlatformQqNeteaseDetail from './PlatformQqNeteaseDetail.vue';
import PlatformAppleSpotifyDetail from './PlatformAppleSpotifyDetail.vue';

export default {
    props: {
        allArtistInfo: {
            type: Array,
            default: () => []
        },
        allArtistValueOptions: {
            type: Array,
            default: () => []
        },
        isAlbum: {
            type: Boolean,
            default: true
        },
        displayLangCode: {
            type: String,
            default: ''
        }
    },
    components: {
        appleSpotifyRelase,
        PlatformQqNeteaseDetail,
        PlatformAppleSpotifyDetail
    },
    data() {
        return {
            visible: false,
            tableData: [],
            fetchLoading: false,
            isView: false,
            platformDrawerVisible: false,
            currentPlatformType: 0,
            currentArtist: null,
            defaultBindMode: false
        };
    },
    computed: {
        platformDrawerTitle() {
            const titleMap = {
                1: '关联Apple Music艺人',
                2: '关联Spotify艺人',
                3: '关联QQ音乐艺人',
                4: '关联网易云音乐艺人'
            };
            return titleMap[this.currentPlatformType] || '关联平台艺人';
        },
        currentArtistInfo() {
            if (!this.currentArtist) return {artistName: '', roleInfo: ''};
            return this.queryArtistRoleInfo(this.currentArtist.id) || {artistName: '', roleInfo: ''};
        }
    },
    methods: {
        async open(flag) {
            this.visible = true;
            this.tableData = [];
            this.isView = flag;
            this.fetchLoading = true;
            this.$nextTick(() => {
                this.fetch();
            });
        },
        async fetch() {
            try {
                this.fetchLoading = true;
                let ids = this.allArtistInfo?.map(item => item.value);
                ids = [...new Set(ids)];
                const res = await fetchListRelateArtist(ids);
                if (!res.data.state) {
                    this.$message.error(res.data.msg || '请求错误');
                    return false;
                }
                this.tableData = res.data.result || [];
            } catch (error) {
                this.$message.error(error.message || '获取数据失败');
            } finally {
                this.fetchLoading = false;
            }
        },
        closed() {
            this.visible = false;
            this.platformDrawerVisible = false;
            this.currentArtist = null;
            this.currentPlatformType = 0;
        },
        parsePlatformInfo(platform) {
            if (!platform) return null;
            let parsedInfo = {};
            if (platform.platformInfo) {
                try {
                    parsedInfo = typeof platform.platformInfo === 'string' ? JSON.parse(platform.platformInfo) : platform.platformInfo;
                } catch (e) {
                    parsedInfo = {};
                }
            }
            // 获取头像：尝试多个可能的字段名，与参考组件逻辑一致
            let avatar = '';
            // Spotify: images数组
            if (parsedInfo.images && parsedInfo.images.length > 0) {
                avatar = parsedInfo.images[0].url || '';
            }
            // QQ/网易云/Apple Music: coverUrl等字段
            if (!avatar) {
                avatar =
                    parsedInfo.coverUrl ||
                    parsedInfo.avatar ||
                    parsedInfo.picUrl ||
                    parsedInfo.img ||
                    parsedInfo.photoUrl ||
                    parsedInfo.pic ||
                    parsedInfo.artworkUrl ||
                    parsedInfo.image ||
                    '';
            }
            // 获取艺人名称：尝试多个可能的字段名
            const name =
                parsedInfo.name ||
                parsedInfo.artistName ||
                parsedInfo.artist ||
                (parsedInfo.names && parsedInfo.names[0] && parsedInfo.names[0].name) ||
                '';
            // 获取主页链接：优先使用platform.artistThirdUrl或platform.platformUrl
            let storeUrl = platform.artistThirdUrl || platform.platformUrl || '';
            if (!storeUrl) {
                // Spotify: externalUrls.spotifyUrl
                if (parsedInfo.externalUrls && parsedInfo.externalUrls.spotifyUrl) {
                    storeUrl = parsedInfo.externalUrls.spotifyUrl;
                } else {
                    storeUrl = parsedInfo.storeURL || parsedInfo.url || '';
                }
            }
            return {
                platformArtistId: platform.platformArtistId || '',
                artistName: name,
                coverUrl: avatar,
                storeUrl: storeUrl
            };
        },
        getPlatformByType(artist, platformType) {
            if (!artist || !artist.artistRelThirdPartyPlatforms) return null;
            return artist.artistRelThirdPartyPlatforms.find(p => Number(p.platformType) === Number(platformType)) || null;
        },
        getPlatformInfo(artist, platformType) {
            const platform = this.getPlatformByType(artist, platformType);
            return this.parsePlatformInfo(platform) || {artistName: '', coverUrl: '', storeUrl: '', platformArtistId: ''};
        },
        getRelatedCount(artist) {
            if (!artist || !artist.artistRelThirdPartyPlatforms) return 0;
            return artist.artistRelThirdPartyPlatforms.filter(p => {
                const status = Number(p.status);
                const type = Number(p.platformType);
                // Apple Music (3): status=1（已关联）和status=2（知名/认证艺人）都算关联
                if (type === 3) {
                    return status === 1 || status === 2;
                }
                // 其他平台（Spotify=4, QQ=2, 网易云=1）：只有status=1算关联
                return status === 1;
            }).length;
        },
        isPlatformBound(artist, platformType) {
            const platform = this.getPlatformByType(artist, platformType);
            if (!platform) return false;
            const status = Number(platform.status);
            const type = Number(platformType);
            // Apple Music (3): status=1和status=2都显示已关联
            if (type === 3) {
                return status === 1 || status === 2;
            }
            // 其他平台：只有status=1显示已关联
            return status === 1;
        },
        queryArtistRoleInfo(targetArtistId) {
            const artistObj = this.allArtistInfo?.filter(item => item.value === targetArtistId);
            if (artistObj.length === 0) {
                return '艺人ID不存在';
            }
            const artistLabel = artistObj[0].label || artistObj[0].name;
            const roleTypes = artistObj?.map(item => item.type);
            const roleNames = roleTypes?.map(type => {
                const roleEntry = this.allArtistValueOptions?.find(role => role.value === type);
                return roleEntry ? roleEntry.name : '未知角色';
            });
            const roleInfoString = roleNames?.join('/ ');
            return {
                artistId: targetArtistId,
                artistName: artistLabel,
                roleInfo: roleInfoString
            };
        },
        isArtistRelated(type, artist) {
            const platformTypeMap = {
                1: 3, // Apple Music
                2: 4, // Spotify
                3: 2, // QQ音乐
                4: 1 // 网易云音乐
            };
            return this.isPlatformBound(artist, platformTypeMap[type]);
        },
        openPlatformDrawer(type, artist) {
            this.currentPlatformType = type;
            this.currentArtist = artist;
            // 如果艺人未关联，直接进入绑定模式
            this.defaultBindMode = !this.isArtistRelated(type, artist);
            this.platformDrawerVisible = true;
        },
        closePlatformDrawer() {
            this.platformDrawerVisible = false;
            this.fetch();
        },
        onPlatformBindChanged() {
            this.fetch();
        },
        async handleUnRelease(type, row) {
            const platformNames = {
                1: 'Apple Music',
                2: 'Spotify',
                3: 'QQ音乐',
                4: '网易云音乐'
            };
            const platformTypeMap = {
                1: 3,
                2: 4,
                3: 2,
                4: 1
            };
            const flag = await this.$confirm(`确认解除该平台艺人管理？`, `${platformNames[type]}解除关联`, {
                confirmButtonText: '确认解除',
                cancelButtonText: '不解除',
                dangerouslyUseHTMLString: true
            }).catch(() => 'cancel');

            if (flag === 'cancel') {
                return;
            }

            try {
                const res = await unrelatePlatformArtist({
                    artistId: row.id,
                    platformType: platformTypeMap[type]
                });

                if (!res.data.state) {
                    this.$message.error(res.data.msg || '解除失败');
                    return;
                }

                this.$message.success('解除成功');
                this.fetch();
            } catch (error) {
                this.$message.error(error.message || '解除失败');
            }
        },
        handleStore(type, row) {
            const platformTypeMap = {
                1: 3, // Apple Music
                2: 4, // Spotify
                3: 2, // QQ音乐
                4: 1 // 网易云音乐
            };
            const platform = this.parsePlatformInfo(this.getPlatformByType(row, platformTypeMap[type]));
            const url = platform && platform.storeUrl;
            if (!url) {
                this.$message.warning('暂无链接');
            } else {
                window.open(url);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.artist-drawer-dialog {
    //position: relative;
    ::v-deep .el-dialog {
        border-radius: 12px;
        margin: 3vh auto !important;
        max-height: 94vh;
        display: flex;
        flex-direction: column;
        position: relative;
    }
    ::v-deep .el-dialog__body {
        border-radius: 12px;
        padding: 16px 20px;
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }
    ::v-deep .el-dialog__header {
        padding: 14px 20px;
        border-bottom: 1px solid #f0f2f5;
        flex-shrink: 0;
        text-align: left !important;
        .el-dialog__title {
            font-size: 18px;
            font-weight: 700;
        }
    }
    ::v-deep .el-dialog__footer {
        padding: 12px 20px;
        border-top: 1px solid #f0f2f5;
        flex-shrink: 0;
    }
}
.drawer-content {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
    .instruction-box {
        background: #f0f7ff;
        border-radius: 8px;
        padding: 12px 16px;
        margin-bottom: 14px;
        flex-shrink: 0;
        .instruction-title {
            font-size: 14px;
            font-weight: 700;
            color: #303133;
            margin-bottom: 8px;
        }
        .instruction-list {
            font-size: 13px;
            color: #606266;
            line-height: 1.7;
        }
    }
    .section-tip {
        font-size: 14px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 12px;
        flex-shrink: 0;
    }
    .artist-list {
        flex: 1;
        overflow-y: auto;
        min-height: 0;
        padding-right: 4px;
        .artist-card-wrapper {
            margin-bottom: 16px;
            &:last-child {
                margin-bottom: 0;
            }
            .artist-info-card {
                border: 1px solid #e4e7ed;
                border-radius: 12px;
                padding: 14px;
                display: flex;
                gap: 14px;
                background: #fff;
                overflow: hidden;
                .artist-left {
                    width: 200px;
                    flex-shrink: 0;
                    .artist-name {
                        font-size: 18px;
                        font-weight: 700;
                        color: #303133;
                        margin-bottom: 8px;
                        word-break: break-all;
                        line-height: 1.3;
                    }
                    .artist-role-tag {
                        display: inline-block;
                        background: #f0f7ff;
                        color: #4080ff;
                        padding: 4px 8px;
                        border-radius: 4px;
                        font-size: 13px;
                        margin-bottom: 12px;
                        word-break: break-all;
                        line-height: 1.5;
                    }
                    .related-count {
                        font-size: 14px;
                        color: #606266;
                        display: flex;
                        align-items: center;
                        gap: 4px;
                        flex-wrap: wrap;
                        i {
                            color: #909399;
                            cursor: pointer;
                        }
                    }
                }
                .platform-cards {
                    flex: 1;
                    min-width: 0;
                    display: grid;
                    grid-template-columns: repeat(4, minmax(0, 1fr));
                    gap: 10px;
                }
            }
        }
    }
}
.dialog-footer-wrapper {
    padding: 16px 0 0 0;
    .footer-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
    }
    .footer-close-btn {
        width: 140px !important;
        height: 44px !important;
        padding: 0 !important;
        font-size: 16px !important;
        border-radius: 6px;
        border: 1px solid #dcdfe6;
        background: #fff;
        color: #606266;
        line-height: 44px !important;
        &:hover,
        &:focus {
            background: #ecf5ff;
            border-color: #c6e2ff;
            color: #409eff;
        }
    }
    .footer-tip {
        font-size: 14px;
        color: #909399;
        display: flex;
        align-items: center;
        gap: 6px;
        text-align: center;
        i {
            color: #909399;
            font-size: 16px;
        }
    }
}

.platform-detail-drawer {
    ::v-deep .el-drawer {
        border-radius: 12px 0 0 12px;
    }
    ::v-deep .el-drawer__header {
        padding: 20px 24px;
        border-bottom: 1px solid #f0f2f5;
        margin-bottom: 0;
        .el-drawer__title {
            font-size: 20px;
            font-weight: 700;
            color: #303133;
        }
    }
    ::v-deep .el-drawer__body {
        padding: 0;
        background: #f5f7fa;
        overflow-y: auto;
    }
    ::v-deep .platform-detail-page {
        margin: 0;
        padding: 0 24px 24px;
        min-height: auto;
        background: transparent;
    }
}

.drawer-artist-info {
    padding: 20px 24px 0;
    .current-artist-box {
        background: #fff;
        border: 1px solid #ebeef5;
        border-radius: 8px;
        padding: 20px;
        margin-bottom: 20px;
        .current-artist-label {
            font-size: 14px;
            color: #909399;
            margin-bottom: 8px;
        }
        .current-artist-name {
            font-size: 24px;
            font-weight: 700;
            color: #303133;
            margin-bottom: 8px;
        }
        .current-artist-role {
            font-size: 14px;
            color: #606266;
        }
    }
}
</style>
